import axios from 'axios'
import type {
  CreateContractRequest,
  CreateContractResponse,
  InsuranceParamsDto,
} from 'BrokerTsLib/src/dtos'
import { useMutation, useQueryClient } from 'react-query'

import { Apis } from '@/appSettings'
import type { CommonMeetingRecord } from '@/dtos/CommonMeetingRecord'

import { useUrl } from '.'

export const useSaveInsuranceParams = () => {
  const url = useUrl(Apis.addonWizard)
  return useMutation((insuranceParams: InsuranceParamsDto) =>
    axios.post(`${url}/SaveInsuranceParams`, insuranceParams),
  )
}

export const useSaveBaseInsuranceParams = () => {
  const url = useUrl(Apis.addonWizard)
  return useMutation((insuranceParams: InsuranceParamsDto) =>
    axios.post(`${url}/SaveBaseParams`, insuranceParams),
  )
}

export const useSaveSelectedAddonInsurance = () => {
  const url = useUrl(Apis.addonWizard)
  return useMutation((paramsId: number) =>
    axios.post(
      `${url}/SaveSelectedAddonInsurance?paramsId=${paramsId}`,
      undefined,
    ),
  )
}

export const useSaveMeetingRecord = () => {
  const url = useUrl(Apis.addonWizard)
  const queryClient = useQueryClient()

  return useMutation(
    (meetingRecord: CommonMeetingRecord) =>
      axios
        .post<CommonMeetingRecord>(`${url}/SaveMeetingRecord`, meetingRecord)
        .then((r) => r.data),
    {
      onSuccess(data, variables, context) {
        queryClient.setQueryData(
          ['getMeetingRecord', variables.paramsId],
          () => {
            return data
          },
        )
      },
    },
  )
}

export const useCreateContract = () => {
  const url = useUrl(Apis.addonWizard)
  return useMutation((request: CreateContractRequest) =>
    axios.post<CreateContractResponse>(`${url}/CreateContract`, request),
  )
}
